(() => {
  const btn = document.getElementById('BackToTop');
  if (!btn) return;

  const showAfter = 600;

  const setVisible = () => {
    const y = window.scrollY || document.documentElement.scrollTop;
    btn.classList.toggle('is-visible', y > showAfter);
  };

  window.addEventListener('scroll', setVisible, { passive: true });
  setVisible();

  btn.addEventListener('click', (e) => {
    e.preventDefault();
    window.scrollTo({ top: 0, behavior: 'smooth' });
  });
})();